// src/utils/helpers.js

/** Format number as Indian currency string */
export function fmt(n) {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n || 0)
}

/** Format currency with ₹ prefix */
export function fmtCur(n, showSign = false) {
  const abs = Math.abs(n || 0)
  const str = '₹' + fmt(abs)
  if (showSign && n < 0) return '−' + str
  if (showSign && n > 0) return '+' + str
  return str
}

/** Today's date as YYYY-MM-DD */
export function today() {
  return new Date().toISOString().split('T')[0]
}

/** Format date string for display */
export function fmtDate(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr + 'T00:00:00')
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
}

/** Short date: 05 May */
export function fmtDateShort(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr + 'T00:00:00')
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })
}

/** Generate a short unique id */
export function uid() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 6)
}

/** Get initials from full name */
export function initials(name = '') {
  return name.trim().split(/\s+/).map(w => w[0] || '').join('').toUpperCase().slice(0, 2)
}

/** Next TXN reference number */
export function nextRef(transactions = []) {
  const nums = transactions.map(t => parseInt(t.ref?.replace('TXN-', '') || '0'))
  const next = nums.length ? Math.max(...nums) + 1 : 1
  return 'TXN-' + String(next).padStart(3, '0')
}

/** Clamp a number between min and max */
export function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max)
}

/** Group array of objects by a key */
export function groupBy(arr, key) {
  return arr.reduce((acc, item) => {
    const k = item[key]
    if (!acc[k]) acc[k] = []
    acc[k].push(item)
    return acc
  }, {})
}

/** Sum an array of numbers */
export function sum(arr) {
  return arr.reduce((s, n) => s + (n || 0), 0)
}
